import React from 'react'
import AvatarWithText from './avatar_with_text'
import { Badge } from '../../elements/badge'
import {
  BadgeAndDate,
  Background,
  Header,
  Author,
  Title,
  Description,
  TitleAndDescription,
  ImageCard,
  Body,
} from './style'
import { Link } from 'gatsby'
import { renderReadMoreTrad } from '../../../utils'

const BlogCard = ({
  theme,
  last_publication_date,
  title,
  description,
  author,
  url,
  image,
  lang,
}: any) => {
  const formatDateByLang = (lang: any, publicationDate: string | number | Date) => {
    let options: any = { year: 'numeric', month: 'long', day: 'numeric' }
    let date = new Date(publicationDate)
    return date.toLocaleDateString(lang, options)
  }

  return (
    <Background>
      <Header>
        <Link to={url}>
          <BadgeAndDate>
            {/* @ts-ignore */}
            <Badge hasHover>{theme}</Badge>
            <p>{formatDateByLang(lang, last_publication_date)}</p>
          </BadgeAndDate>
        </Link>
        <Author>
          {author !== undefined && (
            <AvatarWithText
              name={author.name}
              position={author.position}
              photo={author.photo.url}
              linkedin={author.linkedin}
            />
          )}
        </Author>
      </Header>
      <Body>
        <TitleAndDescription>
          <Link to={url}>
            <Title>{title}</Title>
          </Link>
          <Description>
            <p>{description}</p>
            <Link to={url}>
              <div>{renderReadMoreTrad(lang)} ➜</div>
            </Link>
          </Description>
        </TitleAndDescription>
        <ImageCard>
          <picture>
            <Link to={url}>
              <img src={image} alt={title} />
            </Link>
          </picture>
        </ImageCard>
      </Body>
    </Background>
  )
}

export default BlogCard
